module.exports = __webpack_public_path__ + "img/placeholder.2be4bf18.jpg";